import SettingsGrid from "components/SettingsGrid/SettingsGrid";
import MyDetailsPanel from "personalsettings/mydetailspanel/MyDetailsPanel";
import React from "react";
import { useLoaderData } from "react-router";
import SystemSettingsMenu from "systemsettings/menu/SystemSettingsMenu";

interface SettingsMenuPageProps {
  title: string
  menuGroups: server.dto.OptionMenuGroup[]
  right?: React.ReactNode
}

const SettingsMenuPage = ({ title, menuGroups, right }: SettingsMenuPageProps) =>
  <div>
    <h1 className="settings-menu-title">{title}</h1>
    <div className="settings-menu-body">
      <SettingsGrid menuGroups={menuGroups} />
      {right}
    </div>
  </div>;

export const TemplateSettingsMenuPage = () => {
  return <SettingsMenuPage
    title={desktopNavigation.rightSideNavigation.title}
    menuGroups={desktopNavigation.rightSideNavigation.items}
  />;
}

export const SystemSettingsMenuPage = () => {
  const viewModel = useLoaderData<server.viewmodel.SystemSettingsMenuFrontModel>();

  return <SettingsMenuPage
    title={desktopNavigation.rightSideNavigation.title}
    menuGroups={desktopNavigation.rightSideNavigation.items}
    right={<SystemSettingsMenu viewModel={viewModel} />}
  />
}

export const PersonalSettingsMenuPage = () => {
  const viewModel = useLoaderData<server.viewmodel.PersonalSettingsMenuFrontModel>();

  return <SettingsMenuPage
    title={desktopNavigation.rightSideNavigation.title}
    menuGroups={desktopNavigation.rightSideNavigation.items}
    right={<MyDetailsPanel
      menuItems={desktopNavigation.rightSideNavigation.items}
      config={viewModel.userDetailPanelConfig}
    />}
  />
}